import UserProfilePage from '@/pages/shared/UserProfilePage';

export default UserProfilePage;
